// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"79":"c2818994","271":"d0dab2e7","460":"717eaf2d","479":"92e405bb"}[chunkId] + ".js";
};